import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../../contexts/AuthContext";

export default function AppleCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { appleLogin } = useAuth();

  useEffect(() => {
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      toast.error("การเข้าสู่ระบบด้วย Apple ถูกยกเลิกหรือไม่สำเร็จ");
      navigate("/login");
      return;
    }

    if (!code) {
      toast.error("ไม่พบรหัสจาก Apple");
      navigate("/login");
      return;
    }

    appleLogin(code)
      .then(() => navigate("/"))
      .catch(() => navigate("/login"));
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      กำลังเข้าสู่ระบบด้วย Apple...
    </div>
  );
}